import { type FC } from 'react';
import cn from 'classnames';

interface AvatarProps {
  size: number;
  webp?: string;
  jpg: string;
  className?: string;
}

const Avatar: FC<AvatarProps> = ({ webp, jpg, size, className }) => {
  return (
    <picture
      style={{ width: size + 'px', height: size + 'px' }}
      className={cn('rounded-full overflow-hidden', className)}
    >
      {webp && <source srcSet={webp} type="image/webp" />}
      <img src={jpg} alt="Madelyn Geidt" />
    </picture>
  );
};

export { Avatar };
